import React from 'react';
import slugify from 'react-slugify';
import { VuiEmptyPlaceholder } from '@topkamera/viso-ui';

export const Status403Page = ({
  parentClass, workspace
}) => (
  <main className={`not-found__wrapper not-found__wrapper--middle ${parentClass}`}>
    <VuiEmptyPlaceholder
      title='Access Denied'
      size='lg'
      color='card-border'
      description='You don’t have permissions to access this. Request access from your administrator.'
      icon='lockThin'
      action={{
        label: 'Go Home',
        to: workspace && `/${slugify(workspace.name)}`,
      }}
    />
  </main>
);

export default Status403Page;
